import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import axios from "axios";

const AssignPhleboModal = ({ visible, onHide, order, onAssigned }) => {
  const [selectedPhlebo, setSelectedPhlebo] = useState(null);
  const [phleboList, setPhleboList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchPhleboList = async () => {
    if (!order) return;

       const { orderId, lattitude, longitude } = order;
    const lat = lattitude || '';
    const long=longitude || '';
    console.log(lat,long,order,"gfdgfggt")
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_PHLEBO_BASEURL}phleboList?orderId=${orderId}&lat=${lat}&log=${long}&activeUser=1`,
        // {
        //   orderId,
        //   lat: latitude || 20.300211,
        //   log: longitude || 85.830856,
        // }
      );

      const data = response.data?.data || [];

    const formattedList = data.map((item) => ({
      label: `${item.firstName || ""} ${item.lastName || ""} - ${item.mobile || ""}`.trim(),
      value: item.code,
    }));

    setPhleboList(formattedList);
    } catch (err) {
      toast.error("Failed to fetch phlebo list");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const handleAssign = async () => {
    if (!selectedPhlebo || !order) return;
    try {
      await axios.post(`${process.env.REACT_APP_PHLEBO_BASEURL}order/assign?orderId=${order?.orderId}&userCode=${selectedPhlebo}`, );
      toast.success("Phlebo Assigned Successfully");
      onAssigned(); 
      onHide();
    } catch (error) {
      console.error("Error assigning phlebo:", error);
      toast.error("Failed to assign phlebo");
    }
  };

  useEffect(() => {
    if (visible && order) {
      fetchPhleboList();
    }
  }, [visible, order]);

  return (
    <Dialog
      header="Assign Phlebo"
      visible={visible}
      onHide={() => {
        onHide();
        setSelectedPhlebo(null);
        setPhleboList([]);
      }}
      style={{ width: '30rem' }}
      breakpoints={{ '960px': '75vw', '641px': '90vw' }}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
          <button
            style={{
              backgroundColor: '#00897b',
              color: '#fff',
              padding: '0.5rem 1.5rem',
              border: 'none',
              borderRadius: '4px',
            }}
            onClick={handleAssign}
            disabled={!selectedPhlebo}
          >
            OK
          </button>
          <button
            style={{
              backgroundColor: '#e0e0e0',
              color: '#333',
              padding: '0.5rem 1.5rem',
              border: 'none',
              borderRadius: '4px',
            }}
            onClick={onHide}
          >
            Cancel
          </button>
        </div>
      }
    >
      {loading ? (
        <p>Loading phlebo list...</p>
      ) : (
        <>
          <p style={{ fontWeight: 600, marginBottom: '0.5rem' }}>Select a Phlebo:</p>
          <Dropdown
            value={selectedPhlebo}
            options={phleboList}
            onChange={(e) => setSelectedPhlebo(e.value)}
            placeholder="Choose Phlebo"
            className="w-full"
          />
        </>
      )}
    </Dialog>
  );
};

export default AssignPhleboModal;
